// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AmazonS3Icon = createSvgIcon(
  <svg fill="none" viewBox="0 0 40 48">
    <path
      fill="#E25444"
      fillRule="evenodd"
      d="m36.4 8.3-8.3 15.8 8.3 15.8 3.4-1.9V10.2z"
      clipRule="evenodd"
    />
    <path
      fill="#7B1D13"
      fillRule="evenodd"
      d="m36.4 8.3-16.6 1.9-8.45 13.9L19.8 38l16.6 1.9z"
      clipRule="evenodd"
    />
    <path
      fill="#58150D"
      fillRule="evenodd"
      d="M2.9 8.3.2 9.5v29.2l2.7 1.2 16.9-15.8z"
      clipRule="evenodd"
    />
    <path
      fill="#E25444"
      fillRule="evenodd"
      d="m2.87 8.27 16.96 4.7v22.67L2.87 39.91z"
      clipRule="evenodd"
    />
    <path
      fill="#58150D"
      fillRule="evenodd"
      d="m19.83 15.47-7.2-1.16 7.2-8.18 7.19 8.18z"
      clipRule="evenodd"
    />
    <path
      fill="#58150D"
      fillRule="evenodd"
      d="m27.02 14.31-7.2 1.17-7.19-1.17V6.13M19.83 32.62l-7.2 1.34 7.2 7.02 7.19-7.02z"
      clipRule="evenodd"
    />
    <path
      fill="#7B1D13"
      fillRule="evenodd"
      d="m19.8 0-7.2 3.8v10.5l7.22-2.03zM19.82 18.04l-7.19.79V29.3l7.2.82zM19.82 35.73l-7.19-1.8v10.3l7.2 3.77z"
      clipRule="evenodd"
    />
    <path
      fill="#E25444"
      fillRule="evenodd"
      d="m27.02 33.93-7.2 1.8V48l7.2-3.76zM19.83 18.04l7.19.79V29.3l-7.2.82zM19.8 0 27 3.8v10.5l-7.2-2z"
      clipRule="evenodd"
    />
  </svg>,
  "AmazonS3",
);
export default AmazonS3Icon;
